import { render, staticRenderFns } from "./QueueTable.vue?vue&type=template&id=97c7427a&scoped=true"
import script from "./QueueTable.vue?vue&type=script&lang=js"
export * from "./QueueTable.vue?vue&type=script&lang=js"
import style0 from "./QueueTable.vue?vue&type=style&index=0&id=97c7427a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c7427a",
  null
  
)

export default component.exports